<template>
	<div class="event-show-overview-page">
		<attractions-results-item
		:result="result"
		v-for="(result, index) in getResults"
		:key="index"
		></attractions-results-item>
    	<h2 id="show-no-results" v-if="showNoResults">{{ noResultsText }}</h2>
  	</div>
</template>

<script>
import Vuex from "vuex";
import { mapState, mapGetters } from "vuex";
import attractionsResultsItem from "./attractionsResultsItem.vue";

export default {
  	components: {
    	attractionsResultsItem
  	},
  	computed: {
    	...mapState(["noResultsText", "results"]),
    	getResults() {
      		return this.$store.getters.getResults;
    	},
    	showNoResults() {
      		if (this.results.length === 0) {
        		return true;
      		}
		}
  	},
  	mounted() {
    	var serversideRenderedAttractions = document.querySelector("[data-srr-items]");

		if (serversideRenderedAttractions != null) {
			serversideRenderedAttractions.parentNode.removeChild(serversideRenderedAttractions);
		}
  	}
};
</script>
